import script from "./StatusButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatusButton.vue?vue&type=script&setup=true&lang=ts"

import "./StatusButton.vue?vue&type=style&index=0&id=c1142fb6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1142fb6"]])

export default __exports__